/* eslint-disable react/jsx-key */
//test update
import React, { useState, useEffect } from 'react';
import './App.css';
import SignGreenComp from './components/signgreencomp';
import SignRedComp from './components/signredcomp';
import EntitiesButtonComp from './components/entitiesbuttoncomp'

import ForwardChainingComponent from './functions/rules';
import ListComp from './molecules/listcomp';
import ListNestComp from './molecules/listnestcomp';
import Modal from 'react-modal'
function App() {

  const [facts, setFacts] = useState({});
  const [entities, setEntities]=useState([]);
  const [conclusions, setConclusions] = useState([]);
  


 
  
  
  
  const [family, setFamily] = useState(null);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch('https://go-api-production-8c49.up.railway.app/family');
        const jsonData = await response.json();
        setFamily(jsonData);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();
  }, []);

  const [dataEntities, setDataEntities] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch('https://go-api-production-8c49.up.railway.app/entities');
        const jsonData = await response.json();
        setDataEntities(jsonData);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();
  }, []);


  const [dataRule, setDataRule] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch('https://go-api-production-8c49.up.railway.app/rule');
        const jsonData = await response.json();
        setDataRule(jsonData);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();
  }, []);

  //fetch api data kategori
  const [dataKategori, setDataKategori] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch('https://go-api-production-8c49.up.railway.app/kategori');
        const jsonData = await response.json();
        setDataKategori(jsonData);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();
  }, []);

  //fetch data hotkeys
  const [dataHotkeys, setDataHotkeys] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch('https://go-api-production-8c49.up.railway.app/hotkeys');
        const jsonData = await response.json();
        setDataHotkeys(jsonData);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();
  }, []);

  const [dataOptions, setDataOptions] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch('https://go-api-production-8c49.up.railway.app/options');
        const jsonData = await response.json();
        setDataOptions(jsonData);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    

    fetchData();
  }, []);

    const [isOpen, setIsOpen] = useState(false);
    const [nameentitites, setName] = useState('');
    const [imageentities, setImage] = useState('');

    // for modal 
    const closeDialog = () => {
      setIsOpen(false);
    };
    const modalButtonClick = (nameValue, imageValue) => {
      setName(nameValue);
      setImage(imageValue);
      setIsOpen(true);
    };

  var familyData = family != null ? family['data'] : []
  var entitiesData = dataEntities != null ? dataEntities['data'] : []
  var kategoriData = dataKategori != null ? dataKategori['data'] : []
  var ruleData = dataRule != null ? dataRule['data'] : []
  var kodeData = dataEntities!= null ? dataEntities['data'].map(item => item.kode): []
  var hotkeysData = dataHotkeys != null ? dataHotkeys['data'] : []
  var optionsData = dataOptions != null ? dataOptions['data'] : []

  var [entitiesChoose, setEntitiesChoose] = useState([]);
  var [familyChoose, setFamilyChoose] = useState([]);
  var [kode, setkode] = useState('');

  //rule
  var a = kodeData.map((item)=>({
    condition: ruleData.filter(a => a.kode ===item ).map(b=>b.kode),
    action: () => {setEntities(ruleData.filter(a => a.kode ===item ).map(b=>b.kode));
    setkode(item)},
  }))

  useEffect(() => {
    const applyRules = () => {
      var rules = [
        {
          condition: ['1B', '2A'],
          action: () => {
            setEntities(['1B', '2A']);
            setkode('G01');
          },
        },
        {
          condition: ['1B', '2B', '3B'],
          action: () => {
            setEntities(['1B', '2B', '3B']);
            setkode('G02');
          },
        },
        {
          condition: ['1B', '2B', '3A', '4A'],
          action: () => {
            setEntities(['1B', '2B', '3A', '4A']);
            setkode('G03');
          },
        },
        {
          condition: ['1B', '2B', '3A', '4B'],
          action: () => {
            setEntities(['1B', '2B', '3A', '4B']);
            setkode('G04');
          },
        },
        {
          condition: ['1A', '5A'],
          action: () => {
            setEntities(['1A', '5A']);
            setkode('G05');
          },
        },
        {
          condition: ['1A', '5B', '6A', '7A'],
          action: () => {
            setEntities(['1A', '5B', '6A', '7A']);
            setkode('G06');
          },
        },
        {
          condition: ['1A', '5B', '6A', '7B', '8A', '9A'],
          action: () => {
            setEntities(['1A', '5B', '6A', '7B', '8A', '9A']);
            setkode('G07');
          },
        },
        {
          condition: ['1A', '5B', '6A', '7B', '8A', '9B'],
          action: () => {
            setEntities(['1A', '5B', '6A', '7B', '8A', '9B']);
            setkode('G08');
          },
        },
        {
          condition: ['1A', '5B', '6A', '7B', '8B', '10A'],
          action: () => {
            setEntities(['1A', '5B', '6A', '7B', '8B', '10A']);
            setkode('G09');
          },
        },
        {
          condition: ['1A', '5B', '6A', '7B', '8B', '10B', '11B'],
          action: () => {
            setEntities(['1A', '5B', '6A', '7B', '8B', '10B', '11B']);
            setkode('G10');
          },
        },
        {
          condition: ['1A', '5B', '6A', '7B', '8B', '10B', '11A', '12A', '13A'],
          action: () => {
            setEntities(['1A', '5B', '6A', '7B', '8B', '10B', '11A', '12A', '13A']);
            setkode('G11');
          },
        },
        {
          condition: ['1A', '5B', '6A', '7B', '8B', '10B', '11A', '12A', '13B'],
          action: () => {
            setEntities(['1A', '5B', '6A', '7B', '8B', '10B', '11A', '12A', '13B']);
            setkode('G12');
          },
        },
        {
          condition: ['1A', '5B', '6A', '7B', '8B', '10B', '11A', '12B', '14A'],
          action: () => {
            setEntities(['1A', '5B', '6A', '7B', '8B', '10B', '11A', '12B', '14A']);
            setkode('G13');
          },
        },
        {
          condition: ['1A', '5B', '6A', '7B', '8B', '10B', '11A', '12B', '14B', '15A'],
          action: () => {
            setEntities(['1A', '5B', '6A', '7B', '8B', '10B', '11A', '12B', '14B', '15A']);
            setkode('G14');
          },
        },
        {
          condition: ['1A', '5B', '6A', '7B', '8B', '10B', '11A', '12B', '14B', '15B', '16A'],
          action: () => {
            setEntities(['1A', '5B', '6A', '7B', '8B', '10B', '11A', '12B', '14B', '15B', '16A']);
            setkode('G15');
          },
        },
        {
          condition: ['1A', '5B', '6A', '7B', '8B', '10B', '11A', '12B', '14B', '15B', '16B'],
          action: () => {
            setEntities(['1A', '5B', '6A', '7B', '8B', '10B', '11A', '12B', '14B', '15B', '16B']);
            setkode('G16');
          },
        },
        {
          condition: ['1A', '5B', '6B', '17A'],
          action: () => {
            setEntities(['1A', '5B', '6B', '17A']);
            setkode('G17');
          },
        },
        {
          condition: ['1A', '5B', '6B', '17B', '18A', '19A'],
          action: () => {
            setEntities(['1A', '5B', '6B', '17B', '18A', '19A']);
            setkode('G18');
          },
        },
        {
          condition: ['1A', '5B', '6B', '17B', '18A', '19B'],
          action: () => {
            setEntities(['1A', '5B', '6B', '17B', '18A', '19B']);
            setkode('G19');
          },
        },
        {
          condition: ['1A', '5B', '6B', '17B', '18B', '20A'],
          action: () => {
            setEntities(['1A', '5B', '6B', '17B', '18B', '20A']);
            setkode('G20');
          },
        },
        {
          condition: ['1A', '5B', '6B', '17B', '18B', '20B', '21A'],
          action: () => {
            setEntities(['1A', '5B', '6B', '17B', '18B', '20B', '21A']);
            setkode('G21');
          },
        },
        {
          condition: ['1A', '5B', '6B', '17B', '18B', '20B', '21B', '22A'],
          action: () => {
            setEntities(['1A', '5B', '6B', '17B', '18B', '20B', '21B', '22A']);
            setkode('G22');
          },
        },
        {
          condition: ['1A', '5B', '6B', '17B', '18B', '20B', '21B', '22B', '23A'],
          action: () => {
            setEntities(['1A', '5B', '6B', '17B', '18B', '20B', '21B', '22B', '23A']);
            setkode('G23');
          },
        },
        {
          condition: ['1A', '5B', '6B', '17B', '18B', '20B', '21B', '22B', '23B', '24A', '25A'],
          action: () => {
            setEntities(['1A', '5B', '6B', '17B', '18B', '20B', '21B', '22B', '23B', '24A', '25A']);
            setkode('G24');
          },
        },
        {
          condition: ['1A', '5B', '6B', '17B', '18B', '20B', '21B', '22B', '23B', '24A', '25B', '26A'],
          action: () => {
            setEntities(['1A', '5B', '6B', '17B', '18B', '20B', '21B', '22B', '23B', '24A', '25B', '26A']);
            setkode('G25');
          },
        },
        {
          condition: ['1A', '5B', '6B', '17B', '18B', '20B', '21B', '22B', '23B', '24A', '25B', '26B', '27A'],
          action: () => {
            setEntities(['1A', '5B', '6B', '17B', '18B', '20B', '21B', '22B', '23B', '24A', '25B', '26B', '27A']);
            setkode('G26');
          },
        },
        {
          condition: ['1A', '5B', '6B', '17B', '18B', '20B', '21B', '22B', '23B', '24A', '25B', '26B', '27B', '28A'],
          action: () => {
            setEntities(['1A', '5B', '6B', '17B', '18B', '20B', '21B', '22B', '23B', '24A', '25B', '26B', '27B', '28A']);
            setkode('G27');
          },
        },
        {
          condition: ['1A', '5B', '6B', '17B', '18B', '20B', '21B', '22B', '23B', '24A', '25B', '26B', '27B', '28B', '29A'],
          action: () => {
            setEntities(['1A', '5B', '6B', '17B', '18B', '20B', '21B', '22B', '23B', '24A', '25B', '26B', '27B', '28B', '29A']);
            setkode('G28');
          },
        },
        {
          condition: ['1A', '5B', '6B', '17B', '18B', '20B', '21B', '22B', '23B', '24A', '25B', '26B', '27B', '28B', '29B'],
          action: () => {
            setEntities(['1A', '5B', '6B', '17B', '18B', '20B', '21B', '22B', '23B', '24A', '25B', '26B', '27B', '28B', '29B']);
            setkode('G29');
          },
        },
        {
          condition: ['1A', '5B', '6B', '17B', '18B', '20B', '21B', '22B', '23B', '24B', '30A'],
          action: () => {
            setEntities(['1A', '5B', '6B', '17B', '18B', '20B', '21B', '22B', '23B', '24B', '30A']);
            setkode('G30');
          },
        },
        {
          condition: ['1A', '5B', '6B', '17B', '18B', '20B', '21B', '22B', '23B', '24B', '30B', '31A', '32A'],
          action: () => {
            setEntities(['1A', '5B', '6B', '17B', '18B', '20B', '21B', '22B', '23B', '24B', '30B', '31A', '32A']);
            setkode('G31');
          },
        },
        {
          condition: ['1A', '5B', '6B', '17B', '18B', '20B', '21B', '22B', '23B', '24B', '30B', '31A', '32B', '33A', '34A'],
          action: () => {
            setEntities(['1A', '5B', '6B', '17B', '18B', '20B', '21B', '22B', '23B', '24B', '30B', '31A', '32B', '33A', '34A']);
            setkode('G32');
          },
        },
        {
          condition: ['1A', '5B', '6B', '17B', '18B', '20B', '21B', '22B', '23B', '24B', '30B', '31A', '32B', '33A', '34B', '35A'],
          action: () => {
            setEntities(['1A', '5B', '6B', '17B', '18B', '20B', '21B', '22B', '23B', '24B', '30B', '31A', '32B', '33A', '34B', '35A']);
            setkode('G33');
          },
        },
        {
          condition: ['1A', '5B', '6B', '17B', '18B', '20B', '21B', '22B', '23B', '24B', '30B', '31A', '32B', '33A', '34B', '35B'],
          action: () => {
            setEntities(['1A', '5B', '6B', '17B', '18B', '20B', '21B', '22B', '23B', '24B', '30B', '31A', '32B', '33A', '34B', '35B']);
            setkode('G34');
          },
        },
        {
          condition: ['1A', '5B', '6B', '17B', '18B', '20B', '21B', '22B', '23B', '24B', '30B', '31A', '32B', '33B', '36A'],
          action: () => {
            setEntities(['1A', '5B', '6B', '17B', '18B', '20B', '21B', '22B', '23B', '24B', '30B', '31A', '32B', '33B', '36A']);
            setkode('G35');
          },
        },
        {
          condition: ['1A', '5B', '6B', '17B', '18B', '20B', '21B', '22B', '23B', '24B', '30B', '31A', '32B', '33B', '36B', '37A'],
          action: () => {
            setEntities(['1A', '5B', '6B', '17B', '18B', '20B', '21B', '22B', '23B', '24B', '30B', '31A', '32B', '33B', '36B', '37A']);
            setkode('G36');
          },
        },
        {
          condition: ['1A', '5B', '6B', '17B', '18B', '20B', '21B', '22B', '23B', '24B', '30B', '31A', '32B', '33B', '36B', '37B'],
          action: () => {
            setEntities(['1A', '5B', '6B', '17B', '18B', '20B', '21B', '22B', '23B', '24B', '30B', '31A', '32B', '33B', '36B', '37B']);
            setkode('G37');
          },
        },
        {
          condition: ['1A', '5B', '6B', '17B', '18B', '20B', '21B', '22B', '23B', '24B', '30B', '31B', '38A'],
          action: () => {
            setEntities(['1A', '5B', '6B', '17B', '18B', '20B', '21B', '22B', '23B', '24B', '30B', '31B', '38A']);
            setkode('G38');
          },
        },
        {
          condition: ['1A', '5B', '6B', '17B', '18B', '20B', '21B', '22B', '23B', '24B', '30B', '31B', '38B', '39A', '40A'],
          action: () => {
            setEntities(['1A', '5B', '6B', '17B', '18B', '20B', '21B', '22B', '23B', '24B', '30B', '31B', '38B', '39A', '40A']);
            setkode('G39');
          },
        },
        {
          condition: ['1A', '5B', '6B', '17B', '18B', '20B', '21B', '22B', '23B', '24B', '30B', '31B', '38B', '39A', '40B', '41A'],
          action: () => {
            setEntities(['1A', '5B', '6B', '17B', '18B', '20B', '21B', '22B', '23B', '24B', '30B', '31B', '38B', '39A', '40B', '41A']);
            setkode('G40');
          },
        },
        {
          condition: ['1A', '5B', '6B', '17B', '18B', '20B', '21B', '22B', '23B', '24B', '30B', '31B', '38B', '39A', '40B', '41B', '42A'],
          action: () => {
            setEntities(['1A', '5B', '6B', '17B', '18B', '20B', '21B', '22B', '23B', '24B', '30B', '31B', '38B', '39A', '40B', '41B', '42A']);
            setkode('G41');
          },
        },
        {
          condition: ['1A', '5B', '6B', '17B', '18B', '20B', '21B', '22B', '23B', '24B', '30B', '31B', '38B', '39A', '40B', '41B', '42B'],
          action: () => {
            setEntities(['1A', '5B', '6B', '17B', '18B', '20B', '21B', '22B', '23B', '24B', '30B', '31B', '38B', '39A', '40B', '41B', '42B']);
            setkode('G42');
          },
        },
        {
          condition: ['1A', '5B', '6B', '17B', '18B', '20B', '21B', '22B', '23B', '24B', '30B', '31B', '38B', '39B', '43A'],
          action: () => {
            setEntities(['1A', '5B', '6B', '17B', '18B', '20B', '21B', '22B', '23B', '24B', '30B', '31B', '38B', '39B', '43A']);
            setkode('G43');
          },
        },
        {
          condition: ['1A', '5B', '6B', '17B', '18B', '20B', '21B', '22B', '23B', '24B', '30B', '31B', '38B', '39B', '43B', '44A', '45A'],
          action: () => {
            setEntities(['1A', '5B', '6B', '17B', '18B', '20B', '21B', '22B', '23B', '24B', '30B', '31B', '38B', '39B', '43B', '44A', '45A']);
            setkode('G44');
          },
        },
        {
          condition: ['1A', '5B', '6B', '17B', '18B', '20B', '21B', '22B', '23B', '24B', '30B', '31B', '38B', '39B', '43B', '44A', '45B', '46A'],
          action: () => {
            setEntities(['1A', '5B', '6B', '17B', '18B', '20B', '21B', '22B', '23B', '24B', '30B', '31B', '38B', '39B', '43B', '44A', '45B', '46A']);
            setkode('G45');
          },
        },
        {
          condition: ['1A', '5B', '6B', '17B', '18B', '20B', '21B', '22B', '23B', '24B', '30B', '31B', '38B', '39B', '43B', '44A', '45B', '46B', '47A'],
          action: () => {
            setEntities(['1A', '5B', '6B', '17B', '18B', '20B', '21B', '22B', '23B', '24B', '30B', '31B', '38B', '39B', '43B', '44A', '45B', '46B', '47A']);
            setkode('G46');
          },
        },
        {
          condition: ['1A', '5B', '6B', '17B', '18B', '20B', '21B', '22B', '23B', '24B', '30B', '31B', '38B', '39B', '43B', '44A', '45B', '46B', '47B', '48A', '49A'],
          action: () => {
            setEntities(['1A', '5B', '6B', '17B', '18B', '20B', '21B', '22B', '23B', '24B', '30B', '31B', '38B', '39B', '43B', '44A', '45B', '46B', '47B', '48A', '49A']);
            setkode('G47');
          },
        },
        {
          condition: ['1A', '5B', '6B', '17B', '18B', '20B', '21B', '22B', '23B', '24B', '30B', '31B', '38B', '39B', '43B', '44A', '45B', '46B', '47B', '48A', '49B', '50A'],
          action: () => {
            setEntities(['1A', '5B', '6B', '17B', '18B', '20B', '21B', '22B', '23B', '24B', '30B', '31B', '38B', '39B', '43B', '44A', '45B', '46B', '47B', '48A', '49B', '50A']);
            setkode('G48');
          },
        },
        {
          condition: ['1A', '5B', '6B', '17B', '18B', '20B', '21B', '22B', '23B', '24B', '30B', '31B', '38B', '39B', '43B', '44A', '45B', '46B', '47B', '48A', '49B', '50B', '51A'],
          action: () => {
            setEntities(['1A', '5B', '6B', '17B', '18B', '20B', '21B', '22B', '23B', '24B', '30B', '31B', '38B', '39B', '43B', '44A', '45B', '46B', '47B', '48A', '49B', '50B', '51A']);
            setkode('G49');
          },
        },
        {
          condition: ['1A', '5B', '6B', '17B', '18B', '20B', '21B', '22B', '23B', '24B', '30B', '31B', '38B', '39B', '43B', '44A', '45B', '46B', '47B', '48A', '49B', '50B', '51B', '52A'],
          action: () => {
            setEntities(['1A', '5B', '6B', '17B', '18B', '20B', '21B', '22B', '23B', '24B', '30B', '31B', '38B', '39B', '43B', '44A', '45B', '46B', '47B', '48A', '49B', '50B', '51B', '52A']);
            setkode('G50');
          },
        },
        {
          condition: ['1A', '5B', '6B', '17B', '18B', '20B', '21B', '22B', '23B', '24B', '30B', '31B', '38B', '39B', '43B', '44A', '45B', '46B', '47B', '48A', '49B', '50B', '51B', '52B', '53A', '54A'],
          action: () => {
            setEntities(['1A', '5B', '6B', '17B', '18B', '20B', '21B', '22B', '23B', '24B', '30B', '31B', '38B', '39B', '43B', '44A', '45B', '46B', '47B', '48A', '49B', '50B', '51B', '52B', '53A', '54A']);
            setkode('G51');
          },
        },
        {
          condition: ['1A', '5B', '6B', '17B', '18B', '20B', '21B', '22B', '23B', '24B', '30B', '31B', '38B', '39B', '43B', '44A', '45B', '46B', '47B', '48A', '49B', '50B', '51B', '52B', '53A', '54B', '55A', '56A'],
          action: () => {
            setEntities(['1A', '5B', '6B', '17B', '18B', '20B', '21B', '22B', '23B', '24B', '30B', '31B', '38B', '39B', '43B', '44A', '45B', '46B', '47B', '48A', '49B', '50B', '51B', '52B', '53A', '54B', '55A', '56A']);
            setkode('G52');
          },
        },
        {
          condition: ['1A', '5B', '6B', '17B', '18B', '20B', '21B', '22B', '23B', '24B', '30B', '31B', '38B', '39B', '43B', '44A', '45B', '46B', '47B', '48A', '49B', '50B', '51B', '52B', '53A', '54B', '55A', '56B', '57A'],
          action: () => {
            setEntities(['1A', '5B', '6B', '17B', '18B', '20B', '21B', '22B', '23B', '24B', '30B', '31B', '38B', '39B', '43B', '44A', '45B', '46B', '47B', '48A', '49B', '50B', '51B', '52B', '53A', '54B', '55A', '56B', '57A']);
            setkode('G53');
          },
        },
        {
          condition: ['1A', '5B', '6B', '17B', '18B', '20B', '21B', '22B', '23B', '24B', '30B', '31B', '38B', '39B', '43B', '44A', '45B', '46B', '47B', '48A', '49B', '50B', '51B', '52B', '53A', '54B', '55A', '56B', '57B', '58A', '59A'],
          action: () => {
            setEntities(['1A', '5B', '6B', '17B', '18B', '20B', '21B', '22B', '23B', '24B', '30B', '31B', '38B', '39B', '43B', '44A', '45B', '46B', '47B', '48A', '49B', '50B', '51B', '52B', '53A', '54B', '55A', '56B', '57B', '58A', '59A']);
            setkode('G54');
          },
        },
        {
          condition: ['1A', '5B', '6B', '17B', '18B', '20B', '21B', '22B', '23B', '24B', '30B', '31B', '38B', '39B', '43B', '44A', '45B', '46B', '47B', '48A', '49B', '50B', '51B', '52B', '53A', '54B', '55A', '56B', '57B', '58A', '59B', '60A'],
          action: () => {
            setEntities(['1A', '5B', '6B', '17B', '18B', '20B', '21B', '22B', '23B', '24B', '30B', '31B', '38B', '39B', '43B', '44A', '45B', '46B', '47B', '48A', '49B', '50B', '51B', '52B', '53A', '54B', '55A', '56B', '57B', '58A', '59B', '60A']);
            setkode('G55');
          },
        },
        {
          condition: ['1A', '5B', '6B', '17B', '18B', '20B', '21B', '22B', '23B', '24B', '30B', '31B', '38B', '39B', '43B', '44A', '45B', '46B', '47B', '48A', '49B', '50B', '51B', '52B', '53A', '54B', '55A', '56B', '57B', '58A', '59B', '60B', '61A', '62A'],
          action: () => {
            setEntities(['1A', '5B', '6B', '17B', '18B', '20B', '21B', '22B', '23B', '24B', '30B', '31B', '38B', '39B', '43B', '44A', '45B', '46B', '47B', '48A', '49B', '50B', '51B', '52B', '53A', '54B', '55A', '56B', '57B', '58A', '59B', '60B', '61A', '62A']);
            setkode('G56');
          },
        },
        {
          condition: ['1A', '5B', '6B', '17B', '18B', '20B', '21B', '22B', '23B', '24B', '30B', '31B', '38B', '39B', '43B', '44A', '45B', '46B', '47B', '48A', '49B', '50B', '51B', '52B', '53A', '54B', '55A', '56B', '57B', '58A', '59B', '60B', '61A', '62B', '63A', '64A'],
          action: () => {
            setEntities(['1A', '5B', '6B', '17B', '18B', '20B', '21B', '22B', '23B', '24B', '30B', '31B', '38B', '39B', '43B', '44A', '45B', '46B', '47B', '48A', '49B', '50B', '51B', '52B', '53A', '54B', '55A', '56B', '57B', '58A', '59B', '60B', '61A', '62B', '63A', '64A']);
            setkode('G57');
          },
        },
        {
          condition: ['1A', '5B', '6B', '17B', '18B', '20B', '21B', '22B', '23B', '24B', '30B', '31B', '38B', '39B', '43B', '44A', '45B', '46B', '47B', '48A', '49B', '50B', '51B', '52B', '53A', '54B', '55A', '56B', '57B', '58A', '59B', '60B', '61A', '62B', '63A', '64B', '65A', '66A'],
          action: () => {
            setEntities(['1A', '5B', '6B', '17B', '18B', '20B', '21B', '22B', '23B', '24B', '30B', '31B', '38B', '39B', '43B', '44A', '45B', '46B', '47B', '48A', '49B', '50B', '51B', '52B', '53A', '54B', '55A', '56B', '57B', '58A', '59B', '60B', '61A', '62B', '63A', '64B', '65A', '66A']);
            setkode('G58');
          },
        },
        {
          condition: ['1A', '5B', '6B', '17B', '18B', '20B', '21B', '22B', '23B', '24B', '30B', '31B', '38B', '39B', '43B', '44A', '45B', '46B', '47B', '48A', '49B', '50B', '51B', '52B', '53A', '54B', '55A', '56B', '57B', '58A', '59B', '60B', '61A', '62B', '63A', '64B', '65A', '66B', '67A'],
          action: () => {
            setEntities(['1A', '5B', '6B', '17B', '18B', '20B', '21B', '22B', '23B', '24B', '30B', '31B', '38B', '39B', '43B', '44A', '45B', '46B', '47B', '48A', '49B', '50B', '51B', '52B', '53A', '54B', '55A', '56B', '57B', '58A', '59B', '60B', '61A', '62B', '63A', '64B', '65A', '66B', '67A']);
            setkode('G59');
          },
        },
        {
          condition: ['1A', '5B', '6B', '17B', '18B', '20B', '21B', '22B', '23B', '24B', '30B', '31B', '38B', '39B', '43B', '44A', '45B', '46B', '47B', '48A', '49B', '50B', '51B', '52B', '53A', '54B', '55A', '56B', '57B', '58A', '59B', '60B', '61A', '62B', '63A', '64B', '65A', '66B', '67B', '68A'],
          action: () => {
            setEntities(['1A', '5B', '6B', '17B', '18B', '20B', '21B', '22B', '23B', '24B', '30B', '31B', '38B', '39B', '43B', '44A', '45B', '46B', '47B', '48A', '49B', '50B', '51B', '52B', '53A', '54B', '55A', '56B', '57B', '58A', '59B', '60B', '61A', '62B', '63A', '64B', '65A', '66B', '67B', '68A']);
            setkode('G60');
          },
        },
        {
          condition: ['1A', '5B', '6B', '17B', '18B', '20B', '21B', '22B', '23B', '24B', '30B', '31B', '38B', '39B', '43B', '44A', '45B', '46B', '47B', '48A', '49B', '50B', '51B', '52B', '53A', '54B', '55A', '56B', '57B', '58A', '59B', '60B', '61A', '62B', '63A', '64B', '65A', '66B', '67B', '68A'],
          action: () => {
            setEntities(['1A', '5B', '6B', '17B', '18B', '20B', '21B', '22B', '23B', '24B', '30B', '31B', '38B', '39B', '43B', '44A', '45B', '46B', '47B', '48A', '49B', '50B', '51B', '52B', '53A', '54B', '55A', '56B', '57B', '58A', '59B', '60B', '61A', '62B', '63A', '64B', '65A', '66B', '67B', '68A']);
            setkode('G60');
          },
        },
        {
          condition: ['1A', '5B', '6B', '17B', '18B', '20B', '21B', '22B', '23B', '24B', '30B', '31B', '38B', '39B', '44B', '47B', '48B', '52B', '53B', '54B', '56B', '62B', '63B', '64B', '65B', '66B'],
          action: () => {
            setEntities(['1A', '5B', '6B', '17B', '18B', '20B', '21B', '22B', '23B', '24B', '30B', '31B', '38B', '39B', '44B', '47B', '48B', '52B', '53B', '54B', '56B', '62B', '63B', '64B', '65B', '66B']);
            setkode('G61');
          },
        },
        {
          condition: ['1A', '5B', '6B', '17B', '18B', '20B', '21B', '22B', '23B', '24B', '30B', '31B', '38B', '39B', '44B', '47B', '48B', '52B', '53B', '54B', '56B', '62A'],
          action: () => {
            setEntities(['1A', '5B', '6B', '17B', '18B', '20B', '21B', '22B', '23B', '24B', '30B', '31B', '38B', '39B', '44B', '47B', '48B', '52B', '53B', '54B', '56B', '62A']);
            setkode('G62');
          },
        },
        {
          condition: ['1A', '5B', '6B', '17B', '18B', '20B', '21B', '22B', '23B', '24B', '30B', '31B', '38B', '39B', '44B', '47B', '48B', '52B', '53B', '54B', '56B', '62B', '63A'],
          action: () => {
            setEntities(['1A', '5B', '6B', '17B', '18B', '20B', '21B', '22B', '23B', '24B', '30B', '31B', '38B', '39B', '44B', '47B', '48B', '52B', '53B', '54B', '56B', '62B', '63A']);
            setkode('G63');
          },
        },
        {
          condition: ['1A', '5B', '6B', '17B', '18B', '20B', '21B', '22B', '23B', '24B', '30B', '31B', '38B', '39B', '44B', '47B', '48B', '52B', '53B', '54B', '56B', '62B', '63B', '64A'],
          action: () => {
            setEntities(['1A', '5B', '6B', '17B', '18B', '20B', '21B', '22B', '23B', '24B', '30B', '31B', '38B', '39B', '44B', '47B', '48B', '52B', '53B', '54B', '56B', '62B', '63B', '64A']);
            setkode('G64');
          },
        },
        {
          condition: ['1A', '5B', '6B', '17B', '18B', '20B', '21B', '22B', '23B', '24B', '30B', '31B', '38B', '39B', '44B', '47B', '48B', '52B', '53B', '54B', '56B', '62B', '63B', '64B', '65A'],
          action: () => {
            setEntities(['1A', '5B', '6B', '17B', '18B', '20B', '21B', '22B', '23B', '24B', '30B', '31B', '38B', '39B', '44B', '47B', '48B', '52B', '53B', '54B', '56B', '62B', '63B', '64B', '65A']);
            setkode('G65');
          },
        },
        {
          condition: ['1A', '5B', '6B', '17B', '18B', '20B', '21B', '22B', '23B', '24B', '30B', '31B', '38B', '39B', '44B', '47B', '48B', '52B', '53B', '54B', '56B', '62B', '63B', '64B', '65B', '66A'],
          action: () => {
            setEntities(['1A', '5B', '6B', '17B', '18B', '20B', '21B', '22B', '23B', '24B', '30B', '31B', '38B', '39B', '44B', '47B', '48B', '52B', '53B', '54B', '56B', '62B', '63B', '64B', '65B', '66A']);
            setkode('G66');
          },
        },
        {
          condition: ['1A', '5B', '6B', '17B', '18B', '20B', '21B', '22B', '23B', '24B', '30B', '31B', '38B', '39B', '44B', '47B', '48B', '52B', '53B', '54B', '56B', '62B', '63B', '64B', '65B', '66B'],
          action: () => {
            setEntities(['1A', '5B', '6B', '17B', '18B', '20B', '21B', '22B', '23B', '24B', '30B', '31B', '38B', '39B', '44B', '47B', '48B', '52B', '53B', '54B', '56B', '62B', '63B', '64B', '65B', '66B']);
            setkode('G67');
          },
        },
//rule dysmicoccus
           {
          condition: ['D1A', 'D2A'],
          action: () => {
            setEntities(['D1A', 'D2A']);
            setkode('D01');
          },
        },
        {
          condition: ['D1A', 'D2B', 'D3B', 'D4A'],
          action: () => {
            setEntities(['D1A', 'D2B', 'D3B', 'D4A']);
            setkode('D02');
          },
        },
        {
          condition: ['D1A', 'D2B', 'D3B', 'D4B', 'D5A'],
          action: () => {
            setEntities(['D1A', 'D2B', 'D3B', 'D4B', 'D5A']);
            setkode('D03');
          },
        },
        {
          condition: ['D1A', 'D2B', 'D3B', 'D4B', 'D5A'],
          action: () => {
            setEntities(['D1A', 'D2B', 'D3B', 'D4B', 'D5A']);
            setkode('D04');
          },
        },
        {
          condition: ['D1A', 'D2B', 'D3A', 'D6A'],
          action: () => {
            setEntities(['D1A', 'D2B', 'D3A', 'D6A']);
            setkode('D05');
          },
        },
        {
          condition: ['D1A', 'D2B', 'D3A', 'D6B', 'D7A'],
          action: () => {
            setEntities(['D1A', 'D2B', 'D3A', 'D6B', 'D7A']);
            setkode('D06');
          },
        },
        {
          condition: ['D1A', 'D2B', 'D3A', 'D6B', 'D7B', 'D8A', 'D9A'],
          action: () => {
            setEntities(['D1A', 'D2B', 'D3A', 'D6B', 'D7B', 'D8A', 'D9A']);
            setkode('D07');
          },
        },
        {
          condition: ['D1A', 'D2B', 'D3A', 'D6B', 'D7B', 'D8A', 'D9B'],
          action: () => {
            setEntities(['D1A', 'D2B', 'D3A', 'D6B', 'D7B', 'D8A', 'DB']);
            setkode('D08');
          },
        },
        {
          condition: ['D1A', 'D2B', 'D3A', 'D6B', 'D7B', 'D8B', 'D10A', 'D11A', 'D12A'],
          action: () => {
            setEntities(['D1A', 'D2B', 'D3A', 'D6B', 'D7B', 'D8B', 'D10A', 'D11A', 'D12A']);
            setkode('D09');
          },
        },
        {
          condition: ['D1A', 'D2B', 'D3A', 'D6B', 'D7B', 'D8B', 'D10A', 'D11A', 'D12B', 'D13A'],
          action: () => {
            setEntities(['D1A', 'D2B', 'D3A', 'D6B', 'D7B', 'D8B', 'D10A', 'D11A', 'D12B', 'D13A']);
            setkode('D10');
          },
        },
        {
          condition: ['D1A', 'D2B', 'D3A', 'D6B', 'D7B', 'D8B', 'D10A', 'D11A', 'D12B', 'D13B'],
          action: () => {
            setEntities(['D1A', 'D2B', 'D3A', 'D6B', 'D7B', 'D8B', 'D10A', 'D11A', 'D12B', 'D13B']);
            setkode('D11');
          },
        },
        {
          condition: ['D1A', 'D2B', 'D3A', 'D6B', 'D7B', 'D8B', 'D10A', 'D11B', 'D14A'],
          action: () => {
            setEntities(['D1A', 'D2B', 'D3A', 'D6B', 'D7B', 'D8B', 'D10A', 'D11B', 'D14A']);
            setkode('D12');
          },
        },
        {
          condition: ['D1A', 'D2B', 'D3A', 'D6B', 'D7B', 'D8B', 'D10A', 'D11B', 'D14B'],
          action: () => {
            setEntities(['D1A', 'D2B', 'D3A', 'D6B', 'D7B', 'D8B', 'D10A', 'D11B', 'D14B']);
            setkode('D13');
          },
        },
        {
          condition: ['D1A', 'D2B', 'D3A', 'D6B', 'D7B', 'D8B', 'D10B', 'D15A', 'D16A'],
          action: () => {
            setEntities(['D1A', 'D2B', 'D3A', 'D6B', 'D7B', 'D8B', 'D10B', 'D15A', 'D16A']);
            setkode('D14');
          },
        },
        {
          condition: ['D1A', 'D2B', 'D3A', 'D6B', 'D7B', 'D8B', 'D10B', 'D15A', 'D16B'],
          action: () => {
            setEntities(['D1A', 'D2B', 'D3A', 'D6B', 'D7B', 'D8B', 'D10B', 'D15A', 'D16B']);
            setkode('D15');
          },
        },
        {
          condition: ['D1A', 'D2B', 'D3A', 'D6B', 'D7B', 'D8B', 'D10B', 'D15B', 'D17A'],
          action: () => {
            setEntities(['D1A', 'D2B', 'D3A', 'D6B', 'D7B', 'D8B', 'D10B', 'D15B', 'D17A']);
            setkode('D16');
          },
        },
        {
          condition: ['D1A', 'D2B', 'D3A', 'D6B', 'D7B', 'D8B', 'D10B', 'D15B', 'D17B', 'D18B'],
          action: () => {
            setEntities(['D1A', 'D2B', 'D3A', 'D6B', 'D7B', 'D8B', 'D10B', 'D15B', 'D17B', 'D18B']);
            setkode('D17');
          },
        },
        {
          condition: ['D1A', 'D2B', 'D3A', 'D6B', 'D7B', 'D8B', 'D10B', 'D15B', 'D17B', 'D18A', 'D19A'],
          action: () => {
            setEntities(['D1A', 'D2B', 'D3A', 'D6B', 'D7B', 'D8B', 'D10B', 'D15B', 'D17B', 'D18A', 'D19A']);
            setkode('D18');
          },
        },
        {
          condition: ['D1A', 'D2B', 'D3A', 'D6B', 'D7B', 'D8B', 'D10B', 'D15B', 'D17B', 'D18A', 'D19B'],
          action: () => {
            setEntities(['D1A', 'D2B', 'D3A', 'D6B', 'D7B', 'D8B', 'D10B', 'D15B', 'D17B', 'D18A', 'D19B']);
            setkode('D19');
          },
        },
        {
          condition: ['D1B', 'D20A'],
          action: () => {
            setEntities(['D1B', 'D20A']);
            setkode('D20');
          },
        },
        {
          condition: ['D1B', 'D20B', 'D21A'],
          action: () => {
            setEntities(['D1B', 'D20B', 'D21A']);
            setkode('D21');
          },
        },
        {
          condition: ['D1B', 'D20B', 'D21B', 'D22A'],
          action: () => {
            setEntities(['D1B', 'D20B', 'D21B', 'D22A']);
            setkode('D22');
          },
        },
        {
          condition: ['D1B', 'D20B', 'D21B', 'D22B', 'D23A'],
          action: () => {
            setEntities(['D1B', 'D20B', 'D21B', 'D22B', 'D23A']);
            setkode('D23');
          },
        },
        {
          condition: ['D1B', 'D20B', 'D21B', 'D22B', 'D23B', 'D24A'],
          action: () => {
            setEntities(['D1B', 'D20B', 'D21B', 'D22B', 'D23B', 'D24A']);
            setkode('D24');
          },
        },
        {
          condition: ['D1B', 'D20B', 'D21B', 'D22B', 'D23B', 'D24B', 'D25A'],
          action: () => {
            setEntities(['D1B', 'D20B', 'D21B', 'D22B', 'D23B', 'D24B', 'D25A']);
            setkode('D25');
          },
        },
        {
          condition: ['D1B', 'D20B', 'D21B', 'D22B', 'D23B', 'D24B', 'D25B'],
          action: () => {
            setEntities(['D1B', 'D20B', 'D21B', 'D22B', 'D23B', 'D24B', 'D25B']);
            setkode('D26');
          },
        },
      ];
     
      for (const rule of rules.reverse()) {
        if (rule.condition.every((fact) => facts[fact])) {
          rule.action();
          break; 
        } else {
          setEntities(['']);
          setkode('');
        }
      }
    };
  
    applyRules();
  }, [facts]);
  // var [nowEntities, setNowEntities] = useState('');
  // var [nowCode, setNowCode] = useState([]);
  // var [beforeCode, setBeforeCode] = useState([]);

   const handleCheckboxChange = (fact) => {
    setFacts((prevFacts) => ({ ...prevFacts, [fact]: !prevFacts[fact] }));
  };
  
  const updateFamilyChoose = (id)=> {
    setFamilyChoose((prevEntities) => [...prevEntities, id]);
  }
  const deleteFamilyChoose = (id)=>{
    setFamilyChoose((prevEntities) =>
        prevEntities.filter((item) => item !== id)
      );
  }
   
  const updateEntitiesChoose = (id, fact) => {
    setEntitiesChoose((prevEntities) => [...prevEntities, fact]);
    handleCheckboxChange(fact)
    
  
  };
  const deleteEntitiesChoose = (id,  fact)=>{
    setEntitiesChoose((prevEntities) =>
      prevEntities.filter((item) => item !== fact))
      handleCheckboxChange(fact)
  }

  

  var entitiesFinal = ruleData
  .filter(item => entitiesChoose.includes(item.rule))
  .reduce((acc, curr) => {
    if (entitiesChoose.every(r => ruleData.some(d => d.kode === curr.kode && d.rule === r))) {
      if (!acc.includes(curr.kode)) {
        acc.push(curr.kode);
      }
    }
    return acc;
  }, []);
  console.log(entitiesChoose)
  
  

  return (
    <div>
<Modal isOpen={isOpen} onRequestClose={closeDialog}>
  <div className={'w-full h-full bg-slate-100 p-2 '}>
    <div className='flex flex-row'>
      <div className='flex flex-row'>
        <button className='container w-10 bg-red-500 m-5 p-2 font-bold text-lg ' onClick={closeDialog}>x
        </button>
      </div>
    </div>
    <div className='w-full h-full mt-auto'>
      <img className={'mx-auto w-3/6 pt-5'} src={imageentities}/>
      <p className={'mx-auto w-3/6 text-center font-semibold text-3xl pt-10'}>{nameentitites}</p>
    </div>
  </div>
</Modal>
    
      <div className='contianer w-screen h-screen bg-white flex flex-row'>
        <div className='flex flex-col w-1/2 h-full  '>
          <div className='w-full h-4/5 bg-white '>
    
            <SignGreenComp label='Karakter'/>
    
  
            <div className='h-full overflow-y-auto'>
              <div className='pl-2 '>
              <ListComp grandchild={familyData} title={'Identifikasi (pilih salah satunya)'} type={1} sendData={updateEntitiesChoose} deleteData={deleteEntitiesChoose} sendFamily={updateFamilyChoose} deleteFamily={deleteFamilyChoose}/>

              {familyChoose.includes(1) ?
  kategoriData.filter(kategori => kategori.id === 1).map((kategori) => (
    <ListNestComp
      key={kategori.id}
      id={kategori.id}
      title={kategori.name}
      grandchild={hotkeysData}
      child={optionsData}
      sendData={updateEntitiesChoose}
      deleteData={deleteEntitiesChoose}
    />
  ))
  : null}

                           {familyChoose.includes(2) ?
  kategoriData.filter(kategori => kategori.id === 2).map((kategori) => (
    <ListNestComp
      key={kategori.id}
      id={kategori.id}
      title={kategori.name}
      grandchild={hotkeysData}
      child={optionsData}
      sendData={updateEntitiesChoose}
      deleteData={deleteEntitiesChoose}
    />
  ))
  : null}
              </div>
            </div>
          
    
          </div>
          <div className='w-full h-1/2 bg-white'>
            <SignRedComp label='Karakter yang dipilih'number={familyChoose.length+entitiesChoose.length}/>
            < div className = 'h-5/6 overflow-y-auto' >
              <div className='pl-2  '>
              <ListComp title={'Identifikasi'} list={familyData.filter((data) => familyChoose.includes(data.id))}/>
              
              {entitiesChoose.length > 0 ?
                <ListComp title={'Karakter yang dipilih'} list={optionsData.filter((data) => entitiesChoose.includes(data.value))}/>:null}
                
              </div>
            </div>
          </div>
        </div>
        <div className='flex flex-col w-1/2 h-full bg- '>
          <div className='w-full h-4/5 bg-white'>
            < SignGreenComp label = 'Hasil Identifikasi'
            number = {
              (entitiesFinal.length == 0 && entitiesChoose.length == 0) ?
              entitiesData.length:
              entitiesFinal.length
            }
            />
            <div className='h-full overflow-y-auto'>
              <div className='pl-2 '>
              {
              (entitiesFinal.length == 0 && entitiesChoose.length == 0) ?
              entitiesData.map((data) => (< EntitiesButtonComp key = {data.id}image = {data.image}name = {data.name} onClick={() => modalButtonClick(data.name, data.image)}/>)):
              entitiesData.filter(item => entitiesFinal.includes(item.kode)).map((data) => (< EntitiesButtonComp key = {data.id}image = {data.image}name = {data.name} onClick={() => modalButtonClick(data.name, data.image)}/>))}
              </div>
            </div>
          </div>
          <div className='w-full h-1/2 bg-white'>
            < SignRedComp label = 'Yang dieliminasi'
            number = {
              (entitiesFinal.length == 0 && entitiesChoose.length == 0) ?
              entitiesFinal.length:
              entitiesData.filter((item) => !entitiesFinal.includes(item.kode)).length
              }
            />
            <div className='h-5/6 overflow-y-auto'>
              <div className='pl-2  '>
              
                {
                (entitiesFinal.length == 0 && entitiesChoose.length == 0) ?
                entitiesData.filter(item => entitiesFinal.includes(item.kode)).map((data) => (< EntitiesButtonComp key = {data.id}image = {data.image}name = {data.name} onClick={() => modalButtonClick(data.name, data.image)}/>)):
                entitiesData.filter((item)=> !entitiesFinal.includes(item.kode)).map((data) => (< EntitiesButtonComp key = {data.id}image = {data.image}name = {data.name} onClick={() => modalButtonClick(data.name, data.image)}/>))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
  );
}

export default App;
